import styled from "styled-components";

export const ButtonUnset = styled.button`
  all: unset;
  min-width: 29px;
  min-height: 29px;
  background-color: var(--color-contrast-white, #ffffff);
  cursor: pointer;
`;

export const Alert = styled.span`
  width: 29px;
  text-align: center;
  margin: auto 0;
`
export const AlertContent = styled.p`
  font-size: 32px;
  font-weight: var(--font-weight-semibold);
  color : #eb1a21;
  margin: auto 0;
`

